import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ConstructionIcon from '@mui/icons-material/Construction';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '60px',
        width: 'initial',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: open ? '16px' : 0
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: open ? 1.25 : 0, width: '100%', justifyContent: open ? 'flex-start' : 'center' }}>
        <ConstructionIcon fontSize={open ? 'medium' : 'small'} sx={{ color: 'text.primary' }} />
        {open && (
          <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.secondary' }}>
            Precision Builder
          </Typography>
        )}
      </Box>
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
